import type { ClassLessonAlarmPopupInfo } from '../components/classAlarm/ClassLessonAlarmPopup';

/**
 * 수업 알람 팝업을 다른 탭(메인 프레젠·수업 프레젠 등)에도 표시하기 위한 크로스탭 중계.
 * - 메인 탭(MainLayout의 알람 서비스)이 팝업 상태를 브로드캐스트한다.
 * - 프레젠테이션 탭은 상태를 받아 팝업을 화면에만 표시한다(사운드는 메인 탭에서만 재생).
 * - 어느 탭에서든 알람끄기/팝업닫기는 액션으로 메인 탭에 전달해 세 탭이 같은 상태를 유지한다.
 */
export type ClassLessonAlarmRelayMessage =
  | { kind: 'state'; open: boolean; info: ClassLessonAlarmPopupInfo | null }
  | { kind: 'request-sync' }
  | { kind: 'action'; action: 'stop' | 'close' }
  /** 프레젠테이션 탭 생존 신호(heartbeat). alive=false는 탭 종료 알림 */
  | { kind: 'presence'; alive: boolean };

function channelName(workspaceId: string): string {
  return `cp-class-lesson-alarm-popup:${workspaceId.trim()}`;
}

/** BroadcastChannel 생성(미지원 환경이면 null). */
export function openClassLessonAlarmPopupRelay(workspaceId: string): BroadcastChannel | null {
  const sid = workspaceId.trim();
  if (!sid || typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') {
    return null;
  }
  try {
    return new BroadcastChannel(channelName(sid));
  } catch {
    return null;
  }
}

export function postClassLessonAlarmRelay(
  channel: BroadcastChannel | null,
  message: ClassLessonAlarmRelayMessage
): void {
  if (!channel) return;
  try {
    channel.postMessage(message);
  } catch {
    /* ignore */
  }
}
